<template>
  <div>
    <div v-if="showList" class="table-page">
      <a-tabs :default-active-key="activeEnv" type="card" class="envTab" @change="envTabChange">
        <a-tab-pane :key="item.env" :tab="item.label" v-for="item in envOptions"></a-tab-pane>
      </a-tabs>
      <!--过滤栏 -->
      <search-wrapper>
        <a-row :gutter="20">
          <a-col :span="9" :xs="24" :sm="24" :md="24" :lg="20" :xl="10" :xxl="8">
            <a-form-item label="创建时间">
              <a-range-picker :allowClear="false" v-model="dateRange" format="YYYY-MM-DD HH:mm:ss" showTime style="width: 100%">
                <a-icon slot="suffixIcon" type="calendar" />
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :span="8" :xs="24" :sm="24" :md="24" :lg="14" :xl="12" :xxl="8">
            <a-form-item label="推送类型码" style="width: 100%">
              <a-tree-select v-model="selectIndex" tree-data-simple-mode style="width: 90%; max-width: 320px"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="dictTree" placeholder="请选择推送类型码"
                :load-data="onLoadDictData" />
            </a-form-item>
          </a-col>
          <div class="op-div">
            <a-col :span="10" :xs="18" :sm="18" :md="18" :lg="8" :xl="6" :xxl="6">
              <a-form-item class="operation-group">
                <a-button icon="search" @click="handleSearch">查询</a-button>
                <a-button class="reset-btn" icon="sync" @click="resetSearch">重置</a-button>
              </a-form-item>
            </a-col>
          </div>
        </a-row>
      </search-wrapper>
      <div class="tableWrap">
        <div style="height: 40px">
          <span style="float: left" class="tableTitle">配置列表</span>
          <div style="float: left" v-if="activeEnv != '1'">
            <a-button style="margin-left: 12px" type="primary" @click="handleWhiteList">
              账号白名单
            </a-button>
          </div>
          <div style="float: right">
            <span style="font-size: 14px;font-weight: 400;color: rgba(0, 0, 0, 0.65);line-height: 20px;">共 {{ page.total
            }}
              条</span>
            <a-button style="margin-left: 12px" type="primary" @click="handleAddMessagePush">
              新增配置
            </a-button>
            <a-button style="margin-left: 12px" type="primary" @click="handleModifyMessagePush">
              批量修改
            </a-button>
            <a-button style="margin-left: 12px" type="primary" @click="handleDeleteMessagePush">
              批量删除
            </a-button>
          </div>
        </div>
        <div class="table-page__main">
          <!-- 分页表格 -->
          <div class="drawer-body-page__spin__table-body">
            <a-table :key="refresh" ref="table"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: rowSelection }" rowKey="configId"
              :columns="columns" :pagination="false" :data-source="dataList">
            </a-table>
            <div class="bind-body-page__footer">
              <a-pagination size="small" :current="page.index" :pageSize="page.size" :total="page.total" showSizeChanger
                showQuickJumper :showTotal="() => ``" @change="onChange" @showSizeChange="onChange"
                style="float: right;padding-right: 10px" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAccountWhiteList">
      <account-white-list :is-show="showAccountWhiteList" @backList="backList"></account-white-list>
    </div>
    <div v-if="showAddMessagePush">
      <add-message-push :setMap="setMap" :env="activeEnv" :title="handleTitle" :editItem="editItem"
        @backList="backList"></add-message-push>
    </div>
  </div>
</template>

<script>
import {
  Button, Row, Col, Form,
} from 'ant-design-vue';
import SearchWrapper from '@/components/SearchWrapper';
import {
  devDeleteMessagePush, devGetDictDictionaryList,
  devGetMessageNotifationOrganNoSet, devGetMessageNotifationOrganSet,
  listMessageNotificationOrganConfigByPage,
} from '@/services/modules/my-config';
import AccountWhiteList from '@/views/modules/my-config/AccountWhiteList.vue';
import AddMessagePush from '@/views/modules/my-config/AddMessagePush.vue';

export default {
  name: 'MessagePush',
  components: {
    AddMessagePush,
    AccountWhiteList,
    SearchWrapper,
    'a-row': Row,
    'a-col': Col,
    'a-button': Button,
    'a-form-item': Form.Item,
  },
  data() {
    return {
      refresh: new Date().getTime(),
      handleTitle: '',
      dataList: [],
      page: {
        index: 1,
        size: 10,
        total: 0,
      },
      apps: [],
      showList: true,
      showAccountWhiteList: false,
      showAddMessagePush: false,
      dateRange: this.getInitDateRange(),
      fullWidth: document.documentElement.clientWidth,
      setMap: {},
      selectList: [],
      selectedRowKeys: [],
      editItem: {},
      dictTree: [],
      selectIndex: null,
      activeEnv: '1',
      envOptions: [
        {
          label: '正式环境配置',
          env: '1',
        },
        {
          label: '测试环境配置',
          env: '0',
        },
      ],
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.loadData();
    this.loadDictData();
  },
  computed: {
    columns() {
      return [
        {
          title: '推送码类型',
          key: 'taskType',
          dataIndex: 'taskType',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '显示名称',
          key: 'taskName',
          dataIndex: 'taskName',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '请求地址',
          key: 'targetUrl',
          dataIndex: 'targetUrl',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '最大重试次数',
          key: 'maxRetryCount',
          dataIndex: 'maxRetryCount',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '创建时间',
          key: 'createTime',
          dataIndex: 'createTime',
          align: 'left',
          minWidth: 125,
        },
      ];
    },
    defaultQueryParams() {
      return {
        beginDate: this.dateRange[0] != null ? this.dateRange[0].format('YYYY-MM-DD HH:mm:ss') : null,
        endDate: this.dateRange[1] != null ? this.dateRange[1].format('YYYY-MM-DD HH:mm:ss') : null,
        pageIndex: this.page.index,
        pageSize: this.page.size,
      };
    },
  },
  methods: {
    // 环境tabs change
    envTabChange(key) {
      this.activeEnv = key;
      this.resetSearch();
    },
    loadDictData() {
      const data = {
        parentIndex: 'push',
        showIndex: true,
      };
      devGetDictDictionaryList(data).then(res => {
        console.log(res);
        if (res.success) {
          const { result } = res;
          result.forEach((item) => {
            console.log(item);
            this.dictTree.push({
              id: item.id,
              key: item.key,
              value: item.key,
              title: `${item.value} - ${item.key}`,
              isLeaf: item.isLeaf === '1',
            });
          });
        }
      });
    },
    onLoadDictData(treeNode) {
      return new Promise((resolve) => {
        const data = {
          parentIndex: treeNode.dataRef.key,
          showIndex: true,
        };
        devGetDictDictionaryList(data).then(res => {
          console.log(res);
          if (res.success) {
            // eslint-disable-next-line no-param-reassign
            treeNode.dataRef.children = [];
            const { result } = res;
            result.forEach((item) => {
              console.log(item);
              treeNode.dataRef.children.push({
                id: item.id,
                key: item.key,
                value: item.key,
                title: `${item.value} - ${item.key}`,
                isLeaf: item.isLeaf === '1',
              });
            });
          }
          this.dictTree = [...this.dictTree];
          resolve();
        });
      });
    },
    handleModifyMessagePush() {
      if (this.selectList.length === 0) {
        this.$message.warn('请选择需要修改的推送配置');
        return;
      }
      const data = {
        taskTypeList: [],
        env: this.activeEnv,
      };
      let isDifferent = false;
      this.editItem.editList = [];
      this.selectList.forEach((value) => {
        if (this.selectList[0].targetUrl !== value.targetUrl) {
          isDifferent = true;
        }
        data.taskTypeList.push(value.taskType);
        this.editItem.editList.push({
          configId: value.configId,
          taskType: value.taskType,
        });
      });
      if (isDifferent) {
        const that = this;
        this.$confirm({
          title: '警告',
          content: '信息存“推送地址”不一致，是否继续批量修改',
          onOk() {
            that.executeUpdate(data);
          },
        });
      } else {
        this.executeUpdate(data);
      }
    },
    executeUpdate(data) {
      devGetMessageNotifationOrganSet(data)
        .then(res => {
          if (res && res.result) {
            this.setMap = res.result.messageConfigMap;
            this.handleTitle = '修改配置';
            this.showList = false;
            this.showAddMessagePush = true;
            this.editItem.targetUrl = this.selectList[0].targetUrl;
            this.editItem.maxRetryCount = this.selectList[0].maxRetryCount;
          }
        });
    },
    handleDeleteMessagePush() {
      if (this.selectList.length === 0) {
        this.$message.warn('请选择需要删除的推送配置');
        return;
      }
      const that = this;
      this.$confirm({
        title: '删除',
        content: '是否删除选中推送配置',
        onOk() {
          return new Promise((resolve) => {
            const data = {
              configIds: [],
            };
            that.selectList.forEach((value) => {
              data.configIds.push(value.configId);
            });
            devDeleteMessagePush(data).then(res => {
              if (res.success) {
                that.$message.success('删除成功');
                that.loadData();
              } else {
                that.$message.error(res.errorMessage);
              }
              resolve();
            });
          });
        },
      });
    },
    onChange(index, size) {
      console.log(`index: ${index}`, 'size: ', size);
      this.page.index = index;
      this.page.size = size;
      this.loadData();
    },
    backList() {
      console.log(2);
      this.showList = true;
      this.showAccountWhiteList = false;
      this.showAddMessagePush = false;
      this.loadData();
    },
    handleWhiteList() {
      this.showList = false;
      this.showAccountWhiteList = true;
    },
    handleAddMessagePush() {
      devGetMessageNotifationOrganNoSet({
        env: this.activeEnv,
      }).then(res => {
        if (res && res.result) {
          console.log(res);
          const { length } = Object.keys(res.result.messageConfigMap);
          if (length === 0) {
            this.$message.info('所有类型已设置，无需新增');
            return;
          }
          this.setMap = res.result.messageConfigMap;
          this.handleTitle = '新增配置';
          this.showList = false;
          this.showAddMessagePush = true;
        }
      });
    },
    loadData(parameter) {
      this.dataList = [];
      this.selectedRowKeys = [];
      this.selectList = [];
      this.refresh = new Date().getTime();
      listMessageNotificationOrganConfigByPage({
        env: this.activeEnv, ...parameter, ...this.defaultQueryParams, key: this.selectIndex,
      }).then(res => {
        if (res.success) {
          this.dataList = res.result.result;
          this.page.total = res.result.recordCount;
          console.log(this.dataList);
        }
      });
    },
    handleDateRangeChange(dates) {
      this.dateRange = dates;
      this.handleSearch();
    },
    handleSearch() {
      this.loadData();
    },
    resetSearch() {
      this.dateRange = this.getInitDateRange();
      this.selectIndex = null;
      this.handleSearch();
    },
    getInitDateRange() {
      const defaultSelectDate = {
        startDate: null,
        endDate: null,
        // startDate: moment().startOf('day').subtract(30, 'days'),
        // endDate: moment().startOf('day').add(1, 'days').subtract(1, 'seconds'),
      };
      return [defaultSelectDate.startDate, defaultSelectDate.endDate];
    },
    handleResize() {
      this.fullWidth = document.documentElement.clientWidth;
    },
    rowSelection(selectedRowKeys, selectedRows) {
      this.selectList = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
    },
  },
};
</script>

<style lang="less" scoped>
.drawer-body-page__spin__table-body {
  background: #ffffff;
  padding-bottom: 40px;
  margin-top: 10px;

  .bind-body-page__footer {
    padding-top: 18px;
  }
}

.table-page {
  .op-div {
    /deep/ .ant-col-12 {
      width: 100%;
    }
  }

  /deep/ .ant-tabs {
    margin-bottom: 12px;

    .ant-tabs-nav-container {
      height: 42px
    }
  }

  /deep/ .ant-tabs-top-bar {
    z-index: 999;
  }

  /deep/ .ant-tabs-nav-animated {
    >div:first-child {
      box-sizing: border-box;
      border: 1px #e8e8e8 solid;
      border-radius: 8px;
      background: #ffffff;
      z-index: 999;

      >div:first-child {
        border-right: 1px #e8e8e8 solid;
      }
    }
  }

  /deep/ .ant-tabs-bar {
    border: none;
    height: 42px;

    .ant-tabs-tab {
      margin-right: 0;
      padding: 0px 16px;
      background: none;
      border-radius: 0;
      border-collapse: collapse;
      border: none;
    }
  }

  .tableWrap {
    border-radius: @border-radius-base;
    padding: @padding-lg @padding-lg;
    background: #ffffff;
  }

  .tableTitle {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #25282D;
    line-height: 30px;
    font-weight: 600;
  }
}

.chart-page {
  height: 100%;

  &__chart {
    height: 300px;
  }
}

.userBind__yesterday__statistics__title {
  margin-top: 32px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  text-align: center;
}

.userBind__yesterday__statistics__value {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 40px;
  text-align: center;
}

.userBind__download {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #178FFF;
  line-height: 20px;
  float: right;
  margin-top: 12px;
}
</style>
